module.exports = __webpack_public_path__ + "img/courseSoloImg1.fd005d1d.png";